// extracted by mini-css-extract-plugin
export default {"page":"ErrorPage_page__qBL9O","card":"ErrorPage_card__PIdIF","title":"ErrorPage_title__Q1lRJ","message":"ErrorPage_message__A2hhH","button":"ErrorPage_button__dTWXK"};